// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1__da3f713bf6e76a7a85bc","cls2":"SuggestionReason-cls2__e39463d750e17799de77 SuggestionReason-cls1__da3f713bf6e76a7a85bc"};